/**
 * True price-bucket counts for the collection filters.
 *
 * `updateFixedPriceRangeAvailability()` in section-collection-products.js counts the
 * product cards present in the DOM. With infinite scroll only the first page is there on
 * load, so "Under $1,500 (12)" meant "12 of the products loaded so far" and climbed as the
 * visitor scrolled. This fetches every page of the collection once, harvests the real
 * prices, and parks them on `window.__dcPriceValuesAll` — which that function now prefers.
 *
 * The counts stay hidden until the full set is known. A wrong number next to a price filter
 * is worse than no number, so if the fetch fails they simply never appear.
 */
(function () {
  var CONCURRENCY = 3;

  function section() {
    return document.querySelector('results-list[data-section="collection-products"]')
        || document.querySelector('results-list.collection-products');
  }

  function pricesIn(root) {
    var out = [];
    var cards = root.querySelectorAll('.collection-products__card[data-price-cents]');
    for (var i = 0; i < cards.length; i++) {
      var v = Number(cards[i].getAttribute('data-price-cents') || 0) / 100;
      if (isFinite(v) && v > 0) out.push(v);
    }
    return out;
  }

  // Sequential-ish with a small pool: firing 11 parallel section renders at Shopify tends
  // to get some of them throttled, and a partial answer here is a wrong answer.
  function fetchAll(urls) {
    var results = new Array(urls.length);
    var next = 0;

    function worker() {
      if (next >= urls.length) return Promise.resolve();
      var i = next++;
      return fetch(urls[i], { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('page ' + (i + 1) + ' -> ' + r.status);
          return r.text();
        })
        .then(function (html) {
          results[i] = pricesIn(new DOMParser().parseFromString(html, 'text/html'));
          return worker();
        });
    }

    var pool = [];
    for (var n = 0; n < Math.min(CONCURRENCY, urls.length); n++) pool.push(worker());
    return Promise.all(pool).then(function () { return results; });
  }

  function run() {
    var sec = section();
    if (!sec) return;
    var grid = sec.querySelector('#ResultsList');
    var sectionId = sec.getAttribute('section-id');
    if (!grid || !sectionId) return;

    var lastPage = Math.max(1, Number(grid.dataset.lastPage || 1));

    if (lastPage === 1) {                       // everything is already on the page
      window.__dcPriceValuesAll = pricesIn(sec);
      document.documentElement.classList.add('dc-price-counts-ready');
      document.dispatchEvent(new CustomEvent('collection-products:section-rendered'));
      return;
    }

    var urls = [];
    for (var p = 1; p <= lastPage; p++) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(p));
      u.searchParams.set('section_id', sectionId);
      urls.push(u.toString());
    }

    fetchAll(urls).then(function (pages) {
      var all = [];
      for (var i = 0; i < pages.length; i++) {
        if (!pages[i]) throw new Error('missing page ' + (i + 1));
        all = all.concat(pages[i]);
      }
      window.__dcPriceValuesAll = all;
      document.documentElement.classList.add('dc-price-counts-ready');
      document.dispatchEvent(new CustomEvent('collection-products:section-rendered'));
    }).catch(function () {
      // Leave the counts hidden rather than show a partial tally.
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
